module.exports = __webpack_public_path__ + "media/soundtrack.fac612f8.mp3";